exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.rm-main-container {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"/assets/main.jpg\");\n  background-size: cover;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n}\n.rm-filter {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(27,36,50,0.25);\n}\n.rm-title {\n  font-family: 'Playfair Display', serif;\n  color: #fff;\n  text-align: center;\n  font-size: 5em;\n  text-transform: uppercase;\n  letter-spacing: 10px;\n}\n.rm-subtitle {\n  font-family: 'Lexend', sans-serif;\n  color: #e0e0e0;\n  font-size: 2em;\n  text-align: center;\n  letter-spacing: 5px;\n  text-transform: capitalize;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/main/main.component.styl
// module id = ../../../../../src/app/main/main.component.styl
// module chunks = main